import { doorClient, hiManagerClient, ImResponse, resolve } from 'services/api';

export interface GetTodoListParams {
  storeId: string;
  buyerId: string;
  tradeBuyerId: string;
}

export const getTodoList = (params: GetTodoListParams, signal?: AbortSignal) => {
  return resolve<{
    todoInstanceDetails: Todo.TodoInstance[];
  }>(
    doorClient.get('/overseaim-hi-manager/v1/getTodoInstanceDetailByStoreBuyer', {
      params: {
        store_id: params.storeId,
        buyer_id: params.buyerId,
        tradeBuyerId: params.tradeBuyerId,
      },
      signal,
    }),
  );
};

export const getTodoDetail = (id: string) => {
  return resolve<Todo.TodoInstance>(
    doorClient.get('/overseaim-hi-manager/v1/getTodoInstanceDetail', {
      params: {
        id: id,
      },
    }),
  );
};

export const getAssistants = (storeId: string, signal?: AbortSignal) => {
  return doorClient.get<{
    assistants: {
      id: string;
      name: string;
    }[];
  }>('/overseaim-store-home/v1/assistant/getAssistantsWithPermForTunnel', {
    params: {
      storeId,
      scene: 'VISIT_TODO_MANAGEMENT_CENTER',
    },
    signal,
  });
};

export const updateTodo = (data: { id: string } & Record<string, any>) => {
  return doorClient.post('/overseaim-hi-manager/v1/updateTodoInstance', data);
};

export const closeTodo = (data: { id: string; sendReplyMsg: boolean }) => {
  return doorClient.post('/overseaim-hi-manager/v1/closeTodoInstance', data);
};

export const reopenTodo = (data: { id: string }) => {
  return doorClient.post('/overseaim-hi-manager/v1/reopenTodoInstance', data);
};

type TaskInfo = {
  task: Todo.Task;
  policies: Todo.Policy[];
};

export const getTaskByStoreId = (storeId: string, signal?: AbortSignal) => {
  return resolve<TaskInfo>(
    hiManagerClient.get('todo/store/task', {
      params: {
        store_id: storeId,
      },
      signal,
    }),
  );
};

// 手动创建待办
export const createTodoInstance = (data: Todo.CreateTodoParams) => {
  return hiManagerClient.post<ImResponse<{ id: number }>>('createTodoInstance', data);
};

export const getTodoUserConfig = (signal?: AbortSignal) => {
  return hiManagerClient.get<{
    showOriginalText: boolean;
  }>('userConfig', { signal });
};

export const updateTodoUserConfig = (data: { showOriginalText: boolean }) => {
  return hiManagerClient.post('userConfig', data);
};

export type ErpOrderResult = {
  info: Todo.ErpOrder;
  orders: Todo.ErpOrder[];
};
export const getErpOrder = (todoId: string | number) => {
  return hiManagerClient.get<ErpOrderResult>(`/todo/${todoId}/erp/order`).then((res) => {
    return {
      info: {
        ...res.data.info,
        warehouseCode: res.data.info.warehouseCode ? `${res.data.info.warehouseCode}` : undefined,
      } as Todo.ErpOrder,
      orders: res.data.orders,
    };
  });
};

export const createErpOrder = (body: any) => {
  return hiManagerClient.post('/todo/erp/order', body);
};

export const reviewErpOrder = (
  body: Pick<Todo.ErpOrder, 'todoId' | 'warehouseName' | 'warehouseCode' | 'erpId'>,
) => {
  return hiManagerClient.post('/todo/erp/order/review', body);
};

export const getQyTraceChannel = (params: { storeId: string | number; warehouseName?: string }) => {
  return resolve(
    hiManagerClient.get<
      ImResponse<
        {
          name: string;
          code: string;
        }[]
      >
    >('/todo/erp/trace/channel', { params }),
  );
};

export const getJstTraceChannel = (params: { storeId: string | number }) => {
  return hiManagerClient
    .get<{
      channels: {
        name: string;
        channelType: string;
        channel: {
          name: string;
          code: string;
        }[];
      }[];
    }>('/todo/erp/trace/channel', { params })
    .then((res) => res.data.channels);
};

export const getErpSkus = (
  params:
    | {
        searchType: 'STORE_ITEM';
        storeId: string | number;
        skuId: string;
        skuCode: string;
        page: number;
        pageSize: number;
      }
    | {
        searchType: 'ERP_ITEM';
        storeId: string | number;
        keyword: string;
        erpSearchType: 'SKU_CODE' | 'SKU_NAME';
        page: number;
        pageSize: number;
      },
) => {
  return resolve(
    hiManagerClient.get<ImResponse<Todo.ErpItemSku[]>>('/todo/erp/item/serach', { params }),
  );
};

/**
 * 删除待办
 */
export const deleteTodo = (id: string) => {
  return hiManagerClient.post('deleteTodoInstance', { id });
};
